export default "/assets/website/images/2016.jpeg?46c684dd932ab5616f5a58f31a7158ec";